






















import BaseComponent from '@/components/base-component.vue';
import UiFilterContainer from '@/components/UI/filter-container.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import { listCrmCalendarVisitorsCombo } from '@/services/crm-calendar';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component({
  components: {
    PermissionAuth,
    UiFilterContainer,
  }
})
export default class CalendarVisitFilters extends BaseComponent {
  @Prop()
  public menuMode?: boolean;

  filter: any = {};
  visitors = [];

  onChangeFilter() {
    if (this.menuMode) {
      return;
    }

    this.emitFilter();
  }

  mounted() {
    this.loadCombos();
  }

  emitFilter() {
    this.$emit('filter', this.filter);
  }

  loadCombos() {
    listCrmCalendarVisitorsCombo().subscribe((res) => {
      this.visitors = res;
    });
  }
}
